import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import AppShell from "@/layout/AppShell";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Collections from "@/pages/Collections";
import Reports from "@/pages/Reports";
import Licenses from "@/pages/Licenses";
import Pickups from "@/pages/Pickups";
import Sustainability from "@/pages/Sustainability";
import Invoices from "@/pages/Invoices";
import Trips from "@/pages/Trips";
import SitePhotos from "@/pages/SitePhotos";
import Scheduler from "@/pages/Scheduler";
import Fleet from "@/pages/Fleet";
import Driver from "@/pages/Driver";
import Guides from "@/pages/Guides";
import ResidentGuide from "@/pages/ResidentGuide";
import Staff from "@/pages/Staff";
import WasteCatalog from "@/pages/WasteCatalog";
import Drivers from "@/pages/Drivers";
import Operations from "@/pages/Operations";
import Settings from "@/pages/Settings";

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const RequireInternal = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "driver") return <Navigate to="/driver" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/accept-invite/:token" element={<AcceptInvite mode="invite" />} />
          <Route path="/reset-password/:token" element={<AcceptInvite mode="reset" />} />
          <Route path="/guide/:slug" element={<ResidentGuide />} />
          <Route
            element={
              <RequireInternal>
                <AppShell />
              </RequireInternal>
            }
          >
            <Route path="/app" element={<Dashboard />} />
            <Route path="/app/sustainability" element={<Sustainability />} />
            <Route path="/app/clients" element={<Clients />} />
            <Route path="/app/collections" element={<Collections />} />
            <Route path="/app/reports" element={<Reports />} />
            <Route path="/app/licenses" element={<Licenses />} />
            <Route path="/app/pickups" element={<Pickups />} />
            <Route path="/app/invoices" element={<Invoices />} />
            <Route path="/app/trips" element={<Trips />} />
            <Route path="/app/scheduler" element={<Scheduler />} />
            <Route path="/app/fleet" element={<Fleet />} />
            <Route path="/app/photos" element={<SitePhotos />} />
            <Route path="/app/guides" element={<Guides />} />
            <Route path="/app/staff" element={<Staff />} />
            <Route path="/app/waste-catalog" element={<WasteCatalog />} />
            <Route path="/app/drivers" element={<Drivers />} />
            <Route path="/app/ops" element={<Operations />} />
            <Route path="/app/settings" element={<Settings />} />
          </Route>
          <Route
            path="/driver"
            element={
              <RequireAuth>
                <Driver />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
